import { AppForms } from '@/config'
import { AnyFunction, TypeGuards } from '@codeleap/types'
import { AuthFormComponents, Button, Text, TextInput, View } from '@/components'
import { APIClient } from '@/services'
import { useKeydown } from '@codeleap/web'
import { useLingui } from '@lingui/react/macro'

type ForgotPasswordBeforeFormProps = {
  onRequest?: AnyFunction
}

export const ForgotPasswordBeforeForm = ({ onRequest }: ForgotPasswordBeforeFormProps) => {
  const isValid = AppForms.forgotPassword.use(f => f.isValid)
  const { t } = useLingui()

  const onRequestReset = async () => {
    const email = AppForms.forgotPassword.values.email
    await APIClient.Session.requestPasswordReset(email)
    if (TypeGuards.isFunction(onRequest)) onRequest()
  }

  useKeydown('Enter', () => {
    const isInvalidSubmit = !isValid
    if (isInvalidSubmit) return
    onRequestReset?.()
  }, [isValid])

  return (
    <View style={['flex', 'column']} >
      <Text
        style={['h1', 'extraBold', 'marginBottom:1']}
        text={t`Recover password`}
      />

      <TextInput
        {...AppForms.forgotPassword.register('email')}
        debugName='forgot:email'
        leftIcon={{ name: 'mail', debugName: '' }}
      />

      <View style={['column', 'marginTop:2']}>
        <Button
          text={t`Continue`}
          debugName='Request password reset'
          disabled={!isValid}
          onPress={onRequestReset}
          style={['large', 'fullWidth', !isValid && 'outline']}
        />

        <AuthFormComponents.RedirectLink
          route={'Auth.Login'}
          text={'Go back to'}
          textAction={'Login'}
        />
      </View>
    </View>
  )
}